/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEarnerModeRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {UpdateEarnerModeResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const updateEarnerMode = (request: UpdateEarnerModeRequest, options?: CashRequestOptions) => post<UpdateEarnerModeRequest, UpdateEarnerModeResponse>("/2.0/cash/update-earner-mode", request, {...options, rejectOnError: true })